module.exports = __webpack_public_path__ + "img/sDblMnky_350x350.f9e9df71.jpg";